export default __webpack_public_path__ + "static/media/logo.ddc479dc.svg";